import {Component, OnInit} from '@angular/core';
import {DocumentsServiceService} from '../../documents/documents-service.service';
import {NavigationTableResponseItemModel} from '../../../models/file-table.model';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-garant',
    templateUrl: './garant.component.html',
    styleUrls: ['./garant.component.scss']
})
export class GarantComponent implements OnInit {

    public tableType = 'all';
    public selectedType = 'file';

    constructor(
        public controller: DocumentsServiceService,
        protected router: Router,
        protected activeRoute: ActivatedRoute
    ) {
    }

    ngOnInit(): void {
        this.activeRoute.params.subscribe(params => {
            const obj = {
                id: 0,
                filter: params.filter ? params.filter : 'all'
            };
            if (obj.filter === 'all') {
                obj.id = params.folder ? params.folder : 0;
            } else if (obj.filter === 'collection') {
                obj.id = params.collection ? params.collection : 0;
            }

            this.tableType = obj.filter;

            this.onEventFind(obj);
        });
    }

    onEventFind(request: any = null): void {
        this.controller.loadNav(this.controller.prepare(request));
    }

    onEventTrClick(item: NavigationTableResponseItemModel): void {
        let filterStr = 'all';

        if (this.selectedType === 'file') {
            if (item && item.type_str === 'collection') {
                filterStr = item.type_str;
            }
        }

        if (item.type_str === 'file') {
            void this.router.navigate(['account', 'doc', 'file', item.key]);
        }

        if (item.type_str !== 'file') {
            this.onEventFind(this.controller.prepare({id: item.id, filter: filterStr}));
        }
    }
}
